import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import   store,{persistor} from './app/store'
import { BrowserRouter as Router } from 'react-router-dom'
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { RecoilRoot } from 'recoil';
ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>

    <Provider store={store} >
      <PersistGate loading={null} persistor={persistor}>
          <Router>
              <App />
          </Router>
      </PersistGate>
    </Provider>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
